'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _index = require('components/index');

var _index2 = require('containers/index');

var _playlist = require('redux/modules/playlist');

var _downloads = require('helpers/downloads');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _auth = require('redux/modules/auth');

var _progresspopup = require('redux/modules/progresspopup');

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _responseCodes = require('helpers/responseCodes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var maxFilesToShowToast = 7;
var estimationCorrection = 0;
var wavFormat = 'wav';

var DownloadTracksButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    downloadTracksLoading: state.playlist.downloadTracksLoading,
    user: state.auth.user
  };
}, { downloadTracks: _playlist.downloadTracks, setRedirect: _auth.setRedirect, setLoginData: _auth.setLoginData, showProgressPopup: _progresspopup.show, hideProgressPopup: _progresspopup.hide }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(DownloadTracksButton, _Component);

  function DownloadTracksButton() {
    (0, _classCallCheck3.default)(this, DownloadTracksButton);
    return (0, _possibleConstructorReturn3.default)(this, (DownloadTracksButton.__proto__ || (0, _getPrototypeOf2.default)(DownloadTracksButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(DownloadTracksButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.user && nextProps.user) {
        if (this.props.requireAuth) {
          this.download();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.hideProgressPopup();
    }
  }, {
    key: 'onDownload',
    value: function onDownload() {
      var _props = this.props,
          t = _props.t,
          requireAuth = _props.requireAuth,
          contentKey = _props.contentKey,
          playlistUser = _props.playlistUser,
          tracksNumbers = _props.tracksNumbers;

      if (!tracksNumbers.length) {
        return _toastr2.default.warning(t('Please select tracks to download.'));
      }

      if (requireAuth) {
        this.props.setRedirect('/playlists/fromkey/' + contentKey);
        this.props.setLoginData((0, _extends3.default)({}, playlistUser));
        this.loginDialogEl.getWrappedInstance().getWrappedInstance().open();
      } else {
        this.download();
      }
    }
  }, {
    key: 'getEstimation',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
        var params = _ref2.params;
        var estimation;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.props.downloadTracks((0, _extends3.default)({}, params, { getEstimation: true })).promise;

              case 3:
                estimation = _context.sent;

                if (!(0, _get3.default)(estimation, 'code')) {
                  this.props.showProgressPopup({ timeout: (0, _get3.default)(estimation, 'data.time') + estimationCorrection });
                }
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getEstimation(_x) {
        return _ref.apply(this, arguments);
      }

      return getEstimation;
    }()
  }, {
    key: 'download',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var _props2, t, format, tracksNumbers, contentKey, params, isWaitForArchive, _ref4, code, msg, data, _t, zipFileName;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props2 = this.props, t = _props2.t, format = _props2.format, tracksNumbers = _props2.tracksNumbers, contentKey = _props2.contentKey;
                params = { format: format, tracks: tracksNumbers, key: contentKey };
                isWaitForArchive = tracksNumbers.length <= maxFilesToShowToast && format === wavFormat || format !== wavFormat;

                if (!isWaitForArchive) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 6;
                return this.getEstimation({ params: params });

              case 6:
                _context2.next = 8;
                return this.props.downloadTracks(params).promise;

              case 8:
                _ref4 = _context2.sent;
                code = _ref4.code;
                msg = _ref4.msg;
                data = _ref4.data;

                this.props.hideProgressPopup();
                if (code === _responseCodes.downloadTracksCodes.emailSent) {
                  _toastr2.default.info(t('We\'re preparing your download...'), t('It can take a few minutes to process and secure your files. When your file is ready we will send you an email with a link that will enable you to complete the download process.'), // eslint-disable-line
                  { timeOut: 12000 });
                } else if (code) {
                  _t = t;

                  _toastr2.default.warning(_t(msg));
                }
                zipFileName = data.zipFileName;

                if (zipFileName) {
                  (0, _downloads.download)('' + _config2.default.app.urlParts.audio + zipFileName);
                }

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function download() {
        return _ref3.apply(this, arguments);
      }

      return download;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          t = _props3.t,
          downloadTracksLoading = _props3.downloadTracksLoading,
          title = _props3.title,
          className = _props3.className;


      return _react2.default.createElement(
        _Button2.default,
        {
          className: (0, _classnames2.default)('btn-primary pos-rel', className),
          disabled: downloadTracksLoading,
          onClick: this.onDownload
        },
        title || t('Download'),
        downloadTracksLoading && _react2.default.createElement(_index.Loader, { mask: true }),
        _react2.default.createElement(_index2.LoginDialog, { ref: function ref(el) {
            return _this2.loginDialogEl = el;
          } })
      );
    }
  }]);
  return DownloadTracksButton;
}(_react.Component), _class3.propTypes = {
  className: _propTypes2.default.string,
  contentKey: _propTypes2.default.string,
  downloadTracks: _propTypes2.default.func,
  downloadTracksLoading: _propTypes2.default.bool,
  format: _propTypes2.default.string.isRequired,
  hideProgressPopup: _propTypes2.default.func,
  playlistUser: _propTypes2.default.object,
  requireAuth: _propTypes2.default.bool,
  setLoginData: _propTypes2.default.func,
  setRedirect: _propTypes2.default.func,
  showProgressPopup: _propTypes2.default.func,
  t: _propTypes2.default.func,
  title: _propTypes2.default.string,
  tracksNumbers: _propTypes2.default.array.isRequired,
  user: _propTypes2.default.object
}, _class3.defaultProps = {
  playlistUser: {},
  tracksNumbers: []
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onDownload', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onDownload'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = DownloadTracksButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlist/DownloadTracksButton/DownloadTracksButton.js
// module id = 2038
// module chunks = 1